import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import loginbg from "../../../images/bg-1.jpg";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { loginFunc } from "../../../store/custom-actions/auth/login-actions/LoginSlicer";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import getImageUrl from "../../../utils/getImageUrl";
import { useSettings } from "../../../context/SettingsContext";
function LoginPage(props) {
  const { getSetting } = useSettings();
  const { t } = useTranslation();
  const { loading } = useSelector((state) => state.loginSlicer);
  const dispatch = useDispatch();
  const {
    register,
    watch,
    formState: { errors },
    handleSubmit,
  } = useForm();
  const [showPass, setShowPass] = useState(false);
  const pass = watch("password");
  const navigate = useNavigate();
  const loginFunction = async (formData) => {
    try {
      await dispatch(
        loginFunc({
          data: formData,
        })
      ).then((result) => {
        if (result.payload && result.payload.success == true) {
          navigate("/");
        }
      });
    } catch (error) {
      Swal.fire({
        title: t("Oops!"),
        text: error,
        icon: "error",
      });
    }
  };
  const siteLogo = getSetting("site_logo")?.path;

  return (
    <div
      className="w-100 min-vh-100 d-flex justify-content-center align-items-center"
      style={{
        backgroundImage: `url(${loginbg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-10">
            <div className="bg-white rounded-3 shadow p-4">
              <div className="row g-0 align-items-center">
                <div
                  className="col-md-6 d-flex justify-content-center align-items-center p-3"
                >
                  <img
                    src={getImageUrl(siteLogo)}
                    alt="logo"
                    className="img-fluid"
                  />
                </div>

                <div className="col-md-6 p-3">
                  <h4 className="fw-bold text-center text-md-start mb-4">
                    {t("Sign in your account")}
                  </h4>
                  <form id="login-form" onSubmit={handleSubmit(loginFunction)}>
                    <div className="mb-3">
                      <label className="form-label fw-semibold">
                        {t("Email")}
                      </label>
                      <input
                        {...register("email", {
                          required: t("Email is required"),
                        })}
                        type="email"
                        className="form-control w-100"
                      />
                      {errors.email?.message && (
                        <div className="text-danger small mt-1">
                          {errors.email?.message}
                        </div>
                      )}
                    </div>
                    <div className="mb-3 position-relative">
                      <label className="form-label fw-semibold">
                        {t("Password")}
                      </label>
                      <div className="position-relative">
                        <input
                          {...register("password", {
                            required: t("Password is required"),
                          })}
                          type={showPass ? "text" : "password"}
                          className="form-control w-100 pe-5"
                          style={{ minHeight: "45px" }}
                        />
                        <i
                          className={`fa-regular ${showPass ? "fa-eye-slash" : "fa-eye"
                            } position-absolute top-50 translate-middle-y ${localStorage.getItem("langSlug") === "ar"
                              ? "start-0 ms-3"
                              : "end-0 me-3"
                            } cursor-pointer ${showPass ? "text-primary" : "text-muted"
                            }`}
                          onClick={() => setShowPass(!showPass)}
                          style={{
                            fontSize: "1.2rem",
                            zIndex: 2,
                          }}
                        ></i>
                      </div>

                      {errors.password?.message && (
                        <div className="text-danger small mt-1">
                          {errors.password?.message}
                        </div>
                      )}
                    </div>
                    <div className="d-grid mt-4">
                      <button
                        type="submit"
                        className={`btn btn-primary ${loading ? "opacity-75 disabled" : ""
                          }`}
                      >
                        {loading ? t("Loading") + "..." : t("Sign In Me")}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
